import Bugsnag from 'utils/bugsnag'
import ApiClient from 'api-client/ApiClient'
import parseClusterIdsFromParams from 'app/plugins/infrastructure/components/combinedClusters/parseClusterIdsFromParams'
import createCRUDActions from 'core/helpers/createCRUDActions'
import { namespacesSelector } from 'k8s/components/namespaces/selectors'
import { ActionDataKeys } from 'k8s/DataKeys'
import { flatten } from 'ramda'
import { someAsync } from 'utils/async'
import { pathStr } from 'utils/fp'
import { trackEvent } from 'utils/tracking'

const { qbert } = ApiClient.getInstance()

const namespaceActions = createCRUDActions(ActionDataKeys.Namespaces, {
  listFn: async (params) => {
    Bugsnag.leaveBreadcrumb('Attempting to get namespaces', params)
    const clusterIds = parseClusterIdsFromParams(params)
    return someAsync(clusterIds.map(qbert.getClusterNamespaces)).then(flatten)
  },
  createFn: async ({ clusterId, name }) => {
    Bugsnag.leaveBreadcrumb('Attempting to create new namespace', { clusterId, name })
    const body = { metadata: { name } }
    const created = await qbert.createNamespace(clusterId, body)
    trackEvent('WZ Create New Namespace', {
      id: pathStr('metadata.uid', created),
      clusterId,
      name,
      wizard_step: 'Create Namespace',
      wizard_state: 'Complete',
      wizard_progress: '1 of 1',
      wizard_name: 'Create New Namespace',
    })
    return created
  },
  deleteFn: async ({ id }, currentItems) => {
    const { clusterId, name } = currentItems.find((ns) => ns.id === id)
    Bugsnag.leaveBreadcrumb('Attempting to delete namespace', { id, clusterId, name })
    const response = await qbert.deleteNamespace(clusterId, name)
    trackEvent('WZ Delete Namespace', {
      id,
      clusterId,
      name,
      wizard_step: 'Delete Namespace',
      wizard_state: 'Complete',
      wizard_progress: '1 of 1',
      wizard_name: 'Deleted Namespace',
    })
    return response
  },
  uniqueIdentifier: 'id',
  indexBy: 'clusterId',
  selector: namespacesSelector,
})

export default namespaceActions
